import { install, uninstall } from "@github/hotkey"
import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    install(this.element)
  }

  disconnect() {
    uninstall(this.element)
  }
}
